// 레이어가 표시 가능한지 확인 (3D 구 API — checked 필드 기반, 3D 경로에서 사용)
export const isLayerVisible = (layer: {
  checked: boolean;
  build_complete: boolean;
}): boolean => {
  return layer.checked && layer.build_complete;
};

// 2D 신규 API — show 필드 기반
export const isLayerVisible2d = (layer: {
  show: boolean;
  build_complete: boolean;
}): boolean => {
  return layer.show && layer.build_complete;
};

// 파일 경로에서 레이어 이름/세그먼트 추출 (정의는 2D/3D 공용 위치인 shared/api/gisLayer/layerIds 로 이동)
// 2D 로컬 소비자 호환을 위해 re-export
export {
  extractLayerName,
  extractPathSegment,
  TMS_LAYER_NAME_SEGMENT_INDEX,
} from "src/domains/shared/api/gisLayer/layerIds";

